

import React, { useState, ChangeEvent, useEffect } from "react";
import {
    Box,
    TextField,
    Typography,
    Grid,
    Card,
    CardActionArea,
    CardContent,
} from "@mui/material";

// Material-UI Icons Imports
import {
    SmartToy,
    Memory,
    Campaign,
    Analytics,
    HomeRepairService,
    Plumbing,
    ElectricalServices,
    CleaningServices,
    LocalLaundryService,
    LocalShipping,
    AirportShuttle,
    Construction,
    Foundation,
    Chair,
    Weekend,
    TableRestaurant,
    FormatPaint,
    Wallpaper,
    Roofing,
    BuildCircle,
    MedicalServices,
    Computer,
    Laptop,
    Grass,
    Nature,
    Security,
    HelpOutline,
} from "@mui/icons-material";
import { Category } from "./CategoriesList";


interface PassedProps {
    filteredCategories: Category[];
    handleSelectCategory: (category: Category) => void;
}

// Optionally pass a custom color or style into your icons if desired
const getCategoryIcon = (categoryKey: string) => {
    switch (categoryKey.toLowerCase()) {
        case "ai_services":
            return <SmartToy sx={{ fontSize: 40, color: "#607d8b" }} />;
        case "ai_development":
            return <Memory sx={{ fontSize: 40, color: "#009688" }} />;
        case "digital_marketing":
            return <Campaign sx={{ fontSize: 40, color: "#ec407a" }} />;
        case "web_analytics":
            return <Analytics sx={{ fontSize: 40, color: "#9c27b0" }} />;
        case "home_services":
            return <HomeRepairService sx={{ fontSize: 40, color: "#ff9800" }} />;
        case "plumber":
            return <Plumbing sx={{ fontSize: 40, color: "#42a5f5" }} />;
        case "electrician":
            return <ElectricalServices sx={{ fontSize: 40, color: "#ffeb3b" }} />;
        case "cleaning_services":
            return <CleaningServices sx={{ fontSize: 40, color: "#8bc34a" }} />;
        case "laundry_services":
            return <LocalLaundryService sx={{ fontSize: 40, color: "#03a9f4" }} />;
        case "transport_warehouse_services":
            return <LocalShipping sx={{ fontSize: 40, color: "#795548" }} />;
        case "airport_shuttle":
            return <AirportShuttle sx={{ fontSize: 40, color: "#ba68c8" }} />;
        case "construction_work":
            return <Construction sx={{ fontSize: 40, color: "#ffa726" }} />;
        case "foundation_work":
            return <Foundation sx={{ fontSize: 40, color: "#673ab7" }} />;
        case "furniture_services":
            return <Chair sx={{ fontSize: 40, color: "#d32f2f" }} />;
        case "weekend_services":
            return <Weekend sx={{ fontSize: 40, color: "#f44336" }} />;
        case "table_assembly":
            return <TableRestaurant sx={{ fontSize: 40, color: "#8d6e63" }} />;
        case "finishing_works":
            return <FormatPaint sx={{ fontSize: 40, color: "#7e57c2" }} />;
        case "wallpaper_installation":
            return <Wallpaper sx={{ fontSize: 40, color: "#ec407a" }} />;
        case "roofing_work":
            return <Roofing sx={{ fontSize: 40, color: "#66bb6a" }} />;
        case "appliance_repair":
            return <BuildCircle sx={{ fontSize: 40, color: "#9e9d24" }} />;
        case "medical_equipment_repair":
            return <MedicalServices sx={{ fontSize: 40, color: "#e57373" }} />;
        case "computer_assistance":
            return <Computer sx={{ fontSize: 40, color: "#00acc1" }} />;
        case "laptop_repair":
            return <Laptop sx={{ fontSize: 40, color: "#ffb300" }} />;
        case "garden_park_equipment_repair":
            return <Grass sx={{ fontSize: 40, color: "#43a047" }} />;
        case "nature_services":
            return <Nature sx={{ fontSize: 40, color: "#aed581" }} />;
        case "security_systems_installation_repair":
            return <Security sx={{ fontSize: 40, color: "#f44336" }} />;
        default:
            return <HelpOutline sx={{ fontSize: 40, color: "#bdbdbd" }} />;
    }
};

const MainCategoriesGrid = (props: PassedProps) => {
    return (
        // Main Categories Grid
        <Grid container spacing={3} justifyContent="center">
            {props.filteredCategories.map((category) => (
                <Grid item xs={12} sm={6} md={4} key={category.key}>
                    <Card
                        sx={{
                            borderRadius: 3,
                            transition: "transform 0.2s",
                            "&:hover": {
                                transform: "scale(1.02)",
                            },
                        }}
                    >
                        <CardActionArea
                            onClick={() => props.handleSelectCategory(category)}
                            sx={{
                                padding: 2,
                                textAlign: "center",
                                height: 180,
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                            }}
                        >
                            <Box mb={2}>{getCategoryIcon(category.key)}</Box>
                            <CardContent>
                                <Typography variant="h6" fontWeight="600">
                                    {category.name}
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            ))}
        </Grid>
    )
}

export default MainCategoriesGrid;